import { TimeOffService } from '@app/modules/time-off-v3/services';
import { BulkExportEntityService } from './bulk-export/bulk-export-entity-service.service';
import { JournalEntryReportService } from './journal-entry-report.service';
import { BenefitsDigestService } from './benefits-digest.service';
import { EnhancedPayrollReportingService } from './enhanced-payroll-reporting.service';
import { PayrollDigestService } from './payroll-digest.service';
import { PayrollReportingService } from './payroll-reporting.service';
import { CustomReportsTable } from './tables/custom-reports-table/custom-reports.table';

const Services = [
    BulkExportEntityService,
    CustomReportsTable,
    TimeOffService,
    JournalEntryReportService,
    BenefitsDigestService,
    PayrollDigestService,
    PayrollReportingService,
    EnhancedPayrollReportingService,
];

export {
    Services,
    BulkExportEntityService,
    CustomReportsTable,
    BenefitsDigestService,
    PayrollDigestService,
    PayrollReportingService,
    EnhancedPayrollReportingService,
};
